export const AuthEndpoints = {
  Login: '/auth/login',
  Logout: '/auth/logout',
  RefreshToken: '/auth/refreshtoken',
  VerifyOtp: '/auth/verifyotp',
  ForgotPassword: '/auth/forgotpassword',
  ResetPassword: '/auth/resetpassword',
  ResendOTP: '/auth/resendotp',
  ChangePassword: '/auth/changepassword',
};
export const LookupEndpoints = {
  Lookup: '/lookup',
};
export const CommonEndpoints = {
  Delete: '/delete',
  Countries: '/master/countries',
  Regions: '/master/regions',
  Qualifications: '/master/qualifications',
  Professions: '/master/professions',
  Expertise: '/master/experties',
  Languages: '/master/languages',
  Relationships: '/master/relationships',
  InvoiceItems: '/master/invoice-items',
  Tags: '/master/tag-master-items',
  Pharmacies: '/master/pharmacy-master-items',
  Identities: '/master/id-types',
  Modules: '/master/modules',
  Diagnosis: '/master/diagnosis',
  RXDoseUnit: '/master/rxdose',
  RXFrequency: '/master/rxfrequencies',
  RXFood: '/master/rxfood',
  TimeZone: '/master/timezone',
  Medicine: '/master/medicines',
  VaccineSite: '/master/vaccine-sites',
  VaccineRoute: '/master/vaccine-routes',
  VaccineDoseUnit: '/master/vaccine-doseunits',
  Labs: '/master/labs',
  LabTests: '/master/lab-tests',
  AppointmentTypes: '/master/appointment-types',
  AppointmentTypeManage: '/master/appointment-types-manage',
  EquipmentMasterItems: '/master/equipment-master-items',
  EquipmentMasterItemsManage: '/master/equipment-master-items-manage',
  RoomMasterItems: '/master/room-master-items',
  RoomMasterItemsManage: '/master/room-master-items-manage',
  CarePlanTypesMaster: '/master/careplan-type-master',
  CarePlanTypesMasterManage: '/master/careplan-type-master-manage',
  TaskCategoryMaster: '/master/task-category-master',
  TaskCategoryMasterManage: '/master/task-category-master-manage',
  ReviewCategoryMaster: '/master/review-category-master',
  ReviewCategoryMasterManage: '/master/review-category-master-manage',
  PatientEducationCategories: '/master/patient-education-categories',
  PatientEducationCategoriesManage: '/master/patient-education-categories-manage',
};
export const PatientEndpoints = {
  Patients: '/patients',
  PatientManage: '/patients/manage',
  PatientExport: '/patients/export',
  PatientReferrals: '/patients/referrals',
  PatientReferralExport: '/patients/referrals/export',
  PatientReferralDelete: '/patients/referrals/delete',
  PatientReferralManage: '/patients/referrals/manage',
  PatientReferralPreview: '/patients/referrals/preview',
  PatientSendMail: '/patients/send-mail',
  UploadProfilePhoto: '/patients/upload-profile-photo'
};

export const PatientRecordEndpoints = {
  PatientDiagnosis: '/patients/diagnosis',
  PatientDiagnosisManage: '/patients/diagnosis/manage',
  PatientPrescriptions: '/patients/prescriptions',
  PatientPrescriptionManage: '/patients/prescriptions/manage',
  PatientPrescriptionPreviewDetails: '/patients/prescriptions/preview',
  PatientPrescriptionAppointments: '/patients/prescriptions/appointments',
  PatientAllergies: '/patients/allergies',
  PatientAllergiesManage: '/patients/allergies/manage',
  PatientVitals: '/patients/vitals',
  PatientVitalsManage: '/patients/vitals/manage',
  PatientVitalsPlot: '/patients/vitals/plot',
  PatientInjections: '/patients/injections',
  PatientInjectionsManage: '/patients/injections/manage',
  PatientVaccines: '/patient-vaccines',
  PatientVaccinesManage: '/patient-vaccines/manage',
  PatientVaccinesDelete: '/patient-vaccines/vaccine',
  PatientInvestigationOrders: '/patients/investigation-orders',
  PatientInvestigationOrdersManage: '/patients/investigation-orders/manage',
  PatientInvestigationOrdersDelete: '/patients/investigation-orders/delete',
  PatientInvestigationOrdersPreview: '/patients/investigation-orders/preview',
  PatientInvestigationResults: '/patients/investigation-results',
  PatientInvestigationResultManage: '/patients/investigation-results/manage',
  PatientInvestigationResultsDelete: '/patients/investigation-results/delete',
  PatientQuestionnaires: '/patients/questionnaires',
  PatientQuestionnairesManage: '/patients/questionnaires/manage',
  PatientCorrespondences: '/patients/correspondences',
  PatientAlerts: '/patients/alerts',
  PatientAlertsManage: '/patients/alerts/manage',
  PatientActiveAlert: '/patients/alerts/active',
  PatientPreferredPharmacies: '/patient-pharmacy',
  FamilyAccountMember:'/patients/family-account-member',
  PatientCarePlans: '/patients/careplan/list',
  PatientCarePlansManage: '/patients/careplan/manage',
  PatientCarePlanGoals: '/patients/careplan/goals/list',
  PatientCarePlanGoalsManage: '/patients/careplan/goals/manage',
  PatientCarePlanInterventions: '/patients/careplan/intervention/list',
  PatientCarePlanInterventionsManage: '/patients/careplan/intervention/manage',
  PatientCarePlanFollowUps: '/patients/careplan/followup/list',
  PatientCarePlanFollowUpsManage: '/patients/careplan/followup/manage',
  PatientCarePlanTeam: '/patients/careplan/team/list',
  PatientCarePlanTeamManage: '/patients/careplan/team/manage',
  PatientCarePlanInstructions: '/patients/careplan/instructions/list',
  PatientCarePlanInstructionsManage: '/patients/careplan/instructions/manage',
  PatientCarePlanProgress: '/patients/careplan/progress/list',
  PatientCarePlanProgressManage: '/patients/careplan/progress/manage',
  PatientCarePlanDelete: '/patients/careplan/careplan/delete',
  PatientCarePlanAppointments: '/patients/careplan/appointments',
  PatientNutritionPlans: '/patient-nutrition/list',
  PatientNutritionPlanManage: '/patient-nutrition/manage',
  PatientNutritionPlanDetails: '/patient-nutrition/detail-list',
  PatientNutritionPlanDetailManage: '/patient-nutrition/detail-manage',
  PatientNutritionPlanDelete: '/patient-nutrition/delete',
  PatientNutritionPlanDetailDelete: '/patient-nutrition/detail-delete',
};

export const PatientDocumentEndpoints = {
  PatientDocuments: '/patients/documents',
  UploadDocument: '/patients/upload-document',
};

export const PatientInsuranceEndpoints = {
  PatientInsurances: '/patients/insurance',
  PatientInsuranceManage: '/patients/insurance/manage',
};

export const PatientVisitEndpoints = {
  PatientVisitNotes: '/patients/visits',
  PatientVisitNotesManage: '/patients/visits/manage',
  PatientVisitNotesAppointments: '/patients/visits/appointments',
  PatientVisitCountDashboard: '/patients/visits/count-dashboard',
  PatientVisitTemplatePreview: '/patients/visits/template-preview',
  PatientVisitPreviewDetails: '/patients/visits/preview',
};

export const PatientInvoiceEndpoints = {
  PatientInvoices: '/patients/invoices',
  PatientInvoiceManage: '/patients/invoices-manage',
  PatientInvoiceExport: '/patients/invoices-export',
  PatientInvoicePreview: '/patients/invoices-preview',
  PatientInvoiceItems: '/patients/invoice-items',
  PatientInvoiceAppointments: '/patients/invoices-appointments',
  PatientInvoiceItemsManage: '/patients/invoice-items-manage',
  PatientInvoiceUpdateStatus: '/patients/invoice-status-update',
  PatientPayments: '/patients/payments',
  PatientPaymentManage: '/patients/payments-manage',
  PatientInvoiceCountDashboard: '/patients/count-dashboard',
};

export const ProfessionalEndpoints = {
  Professional: '/professionals',
  ProfessionalManage: '/professionals/manage',
  ProfessionalExport: '/professionals/export',
};

export const PatientEducationEndpoints = {
  PatientEducations: '/patient-educations',
  PatientEducationManage: '/patient-educations/manage',
  PatientEducationDetails: '/patient-educations/',
  PatientEducationDelete: '/patient-educations/delete/',
  PatientEducationStatusUpdate: '/patient-educations/status-update',
};

export const MessageEndpoints = {
  Messages: '/messages',
  MessagesManage: '/messages/manage',
  MessagesFromToUsers: '/messages/from-to-users',
};

export const BroadcastEndpoints = {
  Broadcasts: '/broadcast/list',
  BroadcastsManage: '/broadcast/manage',
  BroadcastDetails: '/broadcast',
};

export const PatientPractitionerEndpoints = {
  PatientPractitioners: '/patient-practitioners',
  PatientPractitionerDetails: '/patient-practitioners/details',
};

export const PatientTagEndpoints = {
  PatientTags: '/patient-tags',
};

export const PatientSMSEndpoints = {
  PatientSMS: '/patients/send-sms',
};
export const PatientEmailEndpoints = {
  PatientEmails: '/patients/send-mail',
};

export const PatientContactEndpoints = {
  PatientContacts: '/patient-contacts',
  PatientContactDetails: '/patient-contacts/details',
};

export const PatientIdentityEndpoints = {
  PatientIdentities: '/patient-identities',
  PatientIdentitiyDetails: '/patient-identities/details',
};

export const DocumentEndpoints = {
  Document: '/documents/downloadfile',
  PrintDetails: '/documents/print-document',
};

export const UserEndpoints = {
  Users: '/users',
  UsersAll: '/users/get-all',
  Permissions: '/users/permissions',
  PermissionsManage: '/users/permissions/manage',
  UserManage: '/users/manage',
  UserExport: '/users/export',
  Staff: '/users/staff',
};

export const RoleEndpoints = {
  Roles: '/roles',
  RoleManage: '/roles/manage',
  RolePermissionManage: '/roles/manage-permission',
};

export const LocationEndpoints = {
  Locations: '/locations',
  LocationManage: '/locations/manage',
  LocationExport: '/locations/export',
  AssignedPractitioner: '/locations/assign-practitioner',
  PractitionerLocation: '/locations/practitioners-locations',
  AssociatedPractitionerDelete: '/locations/associated-practitioner/delete',
};

export const PractitionerEndpoints = {
  Practitioners: '/practitioners',
  PractitionerManage: '/practitioners/manage',
  PractitionerExport: '/practitioners/export',
  PractitionerReminderSettings: '/practitioners/reminder-settings',
  PractitionerReminderSettingsManage: '/practitioners/reminder-settings/manage',
};

export const LeavesEndpoints = {
  Leaves: '/practitioners/leaves',
  LeavesManage: '/practitioners/leaves/manage',
  AppointmentCount: '/practitioners/leaves/appointment-count',
  LeavesCancel: '/practitioners/leaves/cancel-leave',
};

export const WorkingHoursEndpoints = {
  WorkingHours: '/practitioners/working-hours',
  WorkingHoursManage: '/practitioners/working-hours/manage',
};
export const AppointmentEndpoints = {
  Appointment: '/appointments',
  AppointmentGroup: '/appointments/group',
  AppointmentMange: '/appointments/manage',
  AppointmentExport: '/appointments/export',
  AppointmentStatusHistory: '/appointments/appointment-status-history',
  AppointmentGroupStatusHistory: '/appointments/group-appointment-status-history',
  AppointmentCountDashboard: '/appointments/count-dashboard',
  AppointmentOrder: '/appointments/update-order',
  AppointmentValidate: '/appointments/validate',
  AppointmentMangeGroup: '/appointments/manage-group',
};
export const AppointmentRecurrenceEndpoints = {
  Recurrence: '/appointment-recurrence',
};
export const AppointmentRoomAllocationEndpoints = {
  List: '/appointment-room-allocation/list',
  Manage: '/appointment-room-allocation/manage',
  Details: '/appointment-room-allocation/details',
};
export const AppointmentRequestEndpoints = {
  RequestList: '/appointments-requested',
  RequestDetails: '/appointments-requested',
  ConfirmRequest: '/appointments-requested/confirm',
};

export const TemplateEndpoints = {
  VisitNote: '/templates/visit-notes',
  VisitNoteManage: '/templates/visit-notes-manage',
  VisitNoteClone: '/templates/visit-notes-clone',

  Report: '/templates/reports',
  ReportManage: '/templates/reports-manage',
  ReportClone: '/templates/reports-clone',

  SMS: '/templates/sms',
  SMSManage: '/templates/sms-manage',

  Email: '/templates/emails',
  EmailManage: '/templates/emails-manage',
  EmailPreview: '/templates/email-preview',

  Questionnaire: '/templates/forms',
  QuestionnaireClone: '/templates/forms-clone',
  QuestionnaireManage: '/templates/forms-manage',

  FormGroups: '/templates/form-groups',
  FormGroupsManage: '/templates/form-groups-manage',

  Questions: '/templates/questions',
  QuestionsManage: '/templates/questions-manage',
  Placeholders: '/templates/placeholders',
  PushNotification: '/templates/push-notification',
  PushNotificationManage: '/templates/push-notification-manage',
};

export const LogsEndpoints = {
  UserLogins: '/logs/user-activities',
  UserLoginsExport: '/logs/user-activities/export',
  UserLoginsDelete: '/logs/user-activities/delete',
  Credential: '/logs/credentials',
  CredentialExport: '/logs/credentials/export',
  CredentialDelete: '/logs/credentials/delete',
  Email: '/logs/emails',
  EmailResend: '/logs/emails/resend',
  EmailExport: '/logs/emails/export',
  EmailDelete: '/logs/emails/delete',
  SMS: '/logs/sms',
  SMSExport: '/logs/sms/export',
  SMSDelete: '/logs/sms/delete',
  Error: '/logs/errors',
  ErrorExport: '/logs/errors/export',
  ErrorDelete: '/logs/errors/delete',
  ActionLogs: '/logs/actions',
  ActionLogsExport: '/logs/actions/export',
  ActionLogsDelete: '/logs/actions/delete',
  Audit: '/logs/audit',
};

export const NotificationEndpoints = {
  Notifications: '/notifications',
  NotificationsCount: '/notifications/notification-count',
  ModuleNotificationsCount: '/notifications/module-notification-count',
  NotificationsRead: '/notifications/read',
};

export const PushNotificationEndpoints = {
  Subscribe: '/push-notification/subscribe',
  Unsubscribe: '/push-notification/unsubscribe',
  Send: '/push-notification/send',
  SendBulk: '/push-notification/send-bulk',
  SendBroadcast: '/push-notification/send-broadcast',
};

export const TaskEndpoints = {
  Tasks: '/tasks',
  TasksManage: '/tasks/manage',
  TasksDelete: '/tasks/delete',
  TasksGetComment: '/tasks/get-comment',
  TasksManageComment: '/tasks/manage-comment',
};
export const ReviewEndpoints = {
  Reviews: '/patient-reviews',
  Summary: '/patient-reviews/summary',
  Trend: '/patient-reviews/trend',
};
export const PatientExercisePlanEndpoints = {
  PatientExercisePlans: '/patient-exercise/list',
  PatientExercisePlanManage: '/patient-exercise/manage',
  PatientExerciseDetails: '/patient-exercise/detail-list',
  PatientExerciseDetailManage: '/patient-exercise/detail-manage',
  PatientExerciseProgress: '/patient-exercise/progress-list',
  PatientExerciseProgressManage: '/patient-exercise/progress-manage',
};

export const LegalDocumentEndpoints = {
  LegalDocuments: '/master/legal-documents',
  LegalDocumentsManage: '/master/legal-documents-manage',
  ActiveLegalDocuments: '/master/legal-documents/active',
  LegalDocumentDownload: '/legaldocs',
  LegalAcceptanceCreate: '/master/legal-acceptance-create',
};
